import {
  type ListItemIconProps,
  ListItemIcon as MUIListItemIcon,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import { colors } from '../styles/colors';

export const ListItemIcon = withStyles({
  root: {
    marginRight: '10px',
    minWidth: 'inherit',

    '& svg': {
      color: colors.gray.dark,
      width: '16px',
      height: '16px',
    },
  },
})(({ children, ...otherProps }: ListItemIconProps) => (
  <MUIListItemIcon {...otherProps}>{children}</MUIListItemIcon>
));
